import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { ScheduledCallViewInfo } from './ScheduledCallViewInfo/ScheduledCallViewInfo';
import {
  IScheduledCallViewPopupParams,
  useScheduledCallViewPopupPresenter,
} from './ScheduledCallViewPopup.presenter';
import styles from './ScheduledCallViewPopup.styles.m.css';
import { ScheduledCallsInviteesList } from './ScheduledCallsInviteesList/ScheduledCallsInviteesList';

export const ScheduledCallViewPopup: FC<ICommonPopupsProps<IScheduledCallViewPopupParams>> =
  observer((props) => {
    const presenter = useScheduledCallViewPopupPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        isShowHeader
        isOpened
        handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
        onClose={presenter.onClose}
      >
        <div className={styles.container}>
          {presenter.commonScheduledEvent && (
            <ScheduledCallViewInfo
              onStartClick={presenter.onClose}
              onCancel={presenter.hasBackButton ? presenter.onBack : presenter.onClose}
              scheduledEvent={presenter.commonScheduledEvent}
            />
          )}
          <div className={styles.divider} />
          <ScheduledCallsInviteesList
            scheduledEventDetails={presenter.scheduledEventDetails}
            isLoading={presenter.isLoading}
          />
        </div>
      </Popup>
    );
  });
